export interface IApplicationRes {
    records: IApplication[];
    totalRecordCount: number;
}

export interface IDropdownApplications {
  name: string;
  value: number;
  description: string;
  shorthand: string;
  typeID: number;
  typeName: string;
  categoryID: number;
  categoryName: string;
  vendorID: number | null;
  vendorName:string;

}



export interface IApplication {

  applicationID?: number | null;
  name: string;
  TypeID?: number| null;

  Description: string | null;
  Website: string | null;
  Status?: string;
  CategoryID?: number | null;
  VendorID?: number | null;
  OwnerID?: number | null;
  LogInCredentialsRequired: boolean;
  UsageReportRequired?: boolean;
  SingleSignOn: boolean;
  InvoiceToCorpPayables?: boolean;
  FSPrepaid?: boolean;
  PublishInCatalog?: boolean;
  SharepointLink: string | null;
  fileId?: number;
  file?: File;

  LogoPath: string;
  AuthorizationStatus: string | null;
  PaymentMethodDetails: string;
  AdminOption: boolean;

  typeName?: string;
  categoryName?: string;
  vendorName?: string;

  CreatedAt?: string;
  cancelByDate?: string;
  applicationNote?: string;

  CreatedBy?: number | null;
  assignedBundleIds?: number[];
}

export const ApplicationDefaults = {
  getDefault(): IApplication {
    return {
      name: '',
      TypeID: 1,
      Description: null,
      Website: null,
      CategoryID: 1,
      VendorID: null,
      OwnerID: null,

      LogInCredentialsRequired: true,
      UsageReportRequired: false,
      AdminOption: false,
      SingleSignOn: false,
      InvoiceToCorpPayables: false,
      FSPrepaid: false,
      PublishInCatalog: false,
      SharepointLink: null,
      LogoPath: '',
      AuthorizationStatus: null,
      PaymentMethodDetails: '',

      CreatedAt: new Date().toISOString(),
      fileId: 0,
      CreatedBy: null,
      assignedBundleIds: [],
    };
  }
};
